import React from 'react';
import PropTypes from 'prop-types';

const PlanNature = ({ className }) => (
  <svg
    width="1738"
    height="1484"
    viewBox="0 0 1738 1484"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="presentation"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.301 60.5L1219.22 60.829L1737.5 455.089L1350.37 1483.5H40.5L41.301 60.5Z"
      fill="#188766"
    />
    <path
      d="M4.00141 1422L4.79959 4.0007L1179.37 4.32876L1695.5 396.951L1309.64 1422H4.00141Z"
      fill="currentColor"
      stroke="#188766"
      strokeWidth="5"
    />
    <g className="areas">
      <path
        d="M763.691 285.649L719.894 364.979L763.575 441.319L812.685 440.206L856.835 361.935L811.034 284.539L763.691 285.649Z"
        fill="#188766"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M973.983 204.889L950.315 213.036L958.966 238.165L921.194 251.168L928.447 272.238L909.959 278.602L918.142 302.372L926.909 299.354L943.124 346.459L968.68 337.662L960.189 312.997L1028.47 289.491L1012.58 243.307L998.059 248.304L998.05 248.277L989.886 251.087L973.983 204.889Z"
        fill="#188766"
      />
      <path d="M1099.32 156.414L1137.58 223.246L1222.55 209.499L1099.32 156.414Z" fill="#188766" />
      <path d="M803.966 134.146L779.48 201.325L906.303 220.787L803.966 134.146Z" fill="#188766" />
      <path d="M1049.51 80.6889L958.146 118.705L1065.16 145.874L1049.51 80.6889Z" fill="#188766" />
      <path d="M910.553 36.5115L818.876 25.5332L890.104 100.032L910.553 36.5115Z" fill="#188766" />
      <rect x="665.069" y="192.708" width="54.4052" height="49.5965" fill="#188766" />
      <rect x="42.7544" y="613.29" width="330.335" height="299.36" fill="#188766" />
      <rect
        x="294.702"
        y="878.94"
        width="14.4536"
        height="265.645"
        transform="rotate(180 294.702 878.94)"
        fill="#35AB88"
      />
      <rect
        x="289.884"
        y="864.485"
        width="15.4083"
        height="83.2053"
        transform="rotate(-90 289.884 864.485)"
        fill="#35AB88"
      />
      <rect
        x="289.884"
        y="836.752"
        width="15.4083"
        height="83.2053"
        transform="rotate(-90 289.884 836.752)"
        fill="#35AB88"
      />
      <rect
        x="289.884"
        y="809.019"
        width="15.4083"
        height="83.2053"
        transform="rotate(-90 289.884 809.019)"
        fill="#35AB88"
      />
      <rect
        x="289.884"
        y="781.282"
        width="15.4083"
        height="83.2053"
        transform="rotate(-90 289.884 781.282)"
        fill="#35AB88"
      />
      <rect
        x="289.884"
        y="753.552"
        width="15.4083"
        height="83.2053"
        transform="rotate(-90 289.884 753.552)"
        fill="#35AB88"
      />
      <rect
        x="289.884"
        y="725.812"
        width="15.4083"
        height="83.2053"
        transform="rotate(-90 289.884 725.812)"
        fill="#35AB88"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M313.711 651.58C313.417 651.886 313.417 652.437 313.711 652.804L316.121 655.251C316.415 655.618 316.944 655.618 317.297 655.251L327.526 644.546C328.055 643.995 328.995 644.422 328.995 645.219L328.995 694.407C328.995 694.896 329.348 695.264 329.818 695.264L333.17 695.264C333.64 695.264 333.993 694.896 333.993 694.407L333.993 645.219C333.993 644.422 334.875 643.995 335.404 644.546L345.692 655.251C345.985 655.557 346.514 655.557 346.867 655.251L349.219 652.804C349.571 652.437 349.571 651.886 349.219 651.519L336.286 638.06C335.462 637.266 334.404 636.776 333.287 636.776L329.701 636.776C328.584 636.776 327.526 637.266 326.703 638.06L313.711 651.58Z"
        fill="#35AB88"
      />
      <path
        d="M566.468 791.967L552.872 870.89L656 777.709L574.093 745.875L512.083 636.776L485.887 759.138L566.468 791.967Z"
        fill="#188766"
      />
      <path
        d="M153.738 134.146L129.152 141.171C150.226 211.417 192.374 243.027 220.472 250.052C248.571 257.076 280.181 271.125 301.255 295.711C318.114 315.38 334.037 355.42 339.891 372.981L360.964 365.957C322.329 257.076 280.181 246.539 273.157 243.027C266.132 239.515 227.497 232.49 195.886 207.904C169.178 187.132 157.251 149.366 153.738 134.146Z"
        fill="#188766"
      />
      <rect x="2.95166" y="458.78" width="133.224" height="56.1964" fill="#188766" />
      <rect x="52.938" y="1040.52" width="73.0244" height="71.9056" fill="#188766" />
      <path
        d="M147.571 926.135L127.079 955.567L208.3 1031.2L247.793 973.078L147.571 926.135Z"
        fill="#188766"
      />
      <path
        d="M255.617 1123.97L235.871 1093.42L318.209 1018.54L356.211 1079.27L255.617 1123.97Z"
        fill="#188766"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M631.635 1038.04C630.024 1083.77 592.446 1120.34 546.326 1120.34C499.182 1120.34 460.964 1082.13 460.964 1034.98C460.964 987.839 499.182 949.621 546.326 949.621C570.286 949.621 591.94 959.492 607.444 975.39L565.767 1018.19C561.057 1012.74 554.094 1009.3 546.326 1009.3C532.14 1009.3 520.639 1020.8 520.639 1034.98C520.639 1049.17 532.14 1060.67 546.326 1060.67C559.478 1060.67 570.321 1050.79 571.833 1038.04H631.635Z"
        fill="#188766"
      />
      <path
        d="M751.962 727.731L656 641.433L756.104 586.898L795.454 484.035L888.653 564.117L914.887 498.532L938.36 575.85L1020.51 591.037L952.167 626.247L970.807 641.433L930.075 690.45L952.167 758.105L909.364 867.182L814.784 779.507L765.078 770.532L751.962 727.731Z"
        fill="#188766"
      />
      <path d="M763.997 830.942L700.7 887.78L828.585 938.157L763.997 830.942Z" fill="#188766" />
      <path d="M668.527 940.13L656 989.864L744.421 976.97L668.527 940.13Z" fill="#188766" />
      <path d="M728.581 1069.08L739.265 1111.08L812.58 1064.66L728.581 1069.08Z" fill="#188766" />
      <path d="M866 1188.81L792.686 1143.13H927.894L866 1188.81Z" fill="#188766" />
      <path
        d="M972.598 962.974L942.755 1038.13L1012.02 1132.07L1119.23 1110.34V1174.44L1305.28 1244.07V1138.71L1263.28 1081.23L1220.17 1069.08L1265.12 1018.61L1238.96 981.762L1191.07 988.394L1082.39 945.291L1014.97 1018.61L972.598 962.974Z"
        fill="#188766"
      />
      <path d="M748.708 1252.99L740.356 1321.65L842.892 1286.86L748.708 1252.99Z" fill="#188766" />
      <path
        d="M963.52 1254.38L924.549 1292.89L967.696 1329.54L1028.47 1289.64L963.52 1254.38Z"
        fill="#188766"
      />
      <path d="M1216.84 1280.83L1111.52 1254.85L1126.83 1320.26L1216.84 1280.83Z" fill="#188766" />
      <rect x="669.32" y="1376.61" width="478.521" height="30.6227" fill="#188766" />
      <path
        d="M1194.53 658.946L1120.27 742.72L1168.28 733.067L1192.1 764.517L1120.27 841.713L1235.94 887.458L1257.86 921.291L1308.85 912.713V846.954L1347.92 866.968L1417.97 852.673L1490.4 775.001L1272.67 687.659L1316.62 637.133L1194.53 658.946Z"
        fill="#188766"
      />
      <path
        d="M1088.95 390.382L1026.81 417.016L1006.1 461.401L1034.95 497.281L1121.5 456.962L1094.13 515.406L1137.41 576.808L1242.83 608.249L1233.95 483.595L1256.52 442.906L1229.51 405.547L1222.12 282.002L1121.13 327.5L1088.95 390.382Z"
        fill="#188766"
      />
      <path d="M1330.23 218.16L1342.78 368.066L1287.27 288.331L1330.23 218.16Z" fill="#188766" />
      <path d="M1453.73 329.547L1426.03 373.683L1511.39 408.258L1453.73 329.547Z" fill="#188766" />
      <path d="M1425.66 428.269L1343.39 480.248L1493.09 478.356L1425.66 428.269Z" fill="#188766" />
      <path
        d="M1605.23 533.201L1457.25 551.277L1527.58 592.61L1586.18 585.567L1605.23 533.201Z"
        fill="#188766"
      />
      <rect x="373.089" y="1.5" width="239.674" height="428.155" fill="#188766" />
      <rect x="2.90479" y="1145.78" width="610.682" height="278.718" fill="#188766" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.95117 125.998C2.95346 121.869 2.95583 117.801 2.9583 113.797C2.96499 102.878 2.97236 92.4255 2.98043 82.4716C8.10561 76.765 13.8482 71.0742 20.2704 65.5083C62.418 28.9807 124.469 33.8978 150.226 40.9224L146.713 61.9961C144.779 61.8118 142.718 61.5913 140.543 61.3585C115.076 58.6328 73.8698 54.2227 34.3196 86.5817C20.3386 98.0205 10.1425 112.286 2.95117 125.998Z"
        fill="#188766"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.90561 393.676C2.90518 384.87 2.9049 376.15 2.90479 367.519C16.1868 371.688 31.9806 374.346 48.3685 372.98C60.197 371.994 70.3657 370.455 79.5733 369.062C103.175 365.49 120.461 362.874 143.201 372.98C163.323 381.923 178.849 392.201 187.303 397.796C189.473 399.233 191.177 400.361 192.373 401.078L178.324 418.64C165.445 408.103 132.664 387.732 104.565 390.541C89.1244 392.086 78.4352 393.63 69.8119 394.875C58.8201 396.463 51.1849 397.566 41.3439 397.566C32.2587 397.566 18.4733 397.566 2.90561 393.676Z"
        fill="#188766"
      />
      <path
        d="M279.083 444.148C279.083 446.271 277.362 447.993 275.239 447.993C273.116 447.993 271.395 446.271 271.395 444.148C271.395 442.025 273.116 440.304 275.239 440.304C277.362 440.304 279.083 442.025 279.083 444.148Z"
        fill="#188766"
      />
      <path
        d="M290.646 447.993C292.769 447.993 294.49 446.271 294.49 444.148C294.49 442.025 292.769 440.304 290.646 440.304C288.523 440.304 286.801 442.025 286.801 444.148C286.801 446.271 288.523 447.993 290.646 447.993Z"
        fill="#188766"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M273.254 418.64H279.083V425.929H288.661V418.64H294.49V425.929H308.885V451.164C308.885 457.349 303.871 462.363 297.686 462.363H268.631C262.446 462.363 257.432 457.349 257.432 451.164V437.127C257.432 430.942 262.446 425.929 268.631 425.929H273.254V418.64ZM268.631 434.328H300.486V451.164C300.486 452.71 299.232 453.964 297.686 453.964H268.631C267.085 453.964 265.831 452.71 265.831 451.164V437.127C265.831 435.581 267.085 434.328 268.631 434.328Z"
        fill="#188766"
      />
      <path
        d="M235.917 445.073C242.069 446.411 247.209 450.923 247.209 457.151C247.209 463.055 242.589 467.417 236.866 468.995V479.608C236.866 483.474 240 486.608 243.865 486.608H250.419C251.311 478.951 257.818 473.009 265.713 473.009H300.772C308.667 473.009 315.175 478.951 316.066 486.608H322.621C326.486 486.608 329.62 483.474 329.62 479.608V468.995C323.897 467.417 319.277 463.055 319.277 457.151C319.277 450.923 324.417 446.411 330.569 445.073V450.83C326.963 451.984 324.876 454.699 324.876 457.151C324.876 460.37 328.471 464.041 334.38 464.041C340.289 464.041 343.884 460.37 343.884 457.151C343.884 454.699 341.798 451.985 338.194 450.831V445.073C344.345 446.413 349.483 450.924 349.483 457.151C349.483 463.437 344.247 467.974 338.019 469.266V479.608C338.019 488.113 331.125 495.007 322.621 495.007H316.17V533.284H307.771V488.407C307.771 484.542 304.637 481.408 300.772 481.408H265.713C261.848 481.408 258.714 484.542 258.714 488.407V533.284H250.315V495.007H243.865C235.361 495.007 228.467 488.113 228.467 479.608V469.266C222.239 467.974 217.003 463.437 217.003 457.151C217.003 450.924 222.141 446.413 228.292 445.073V450.831C224.688 451.985 222.602 454.699 222.602 457.151C222.602 460.37 226.197 464.041 232.106 464.041C238.015 464.041 241.61 460.37 241.61 457.151C241.61 454.699 239.524 451.984 235.917 450.83V445.073Z"
        fill="#188766"
      />
    </g>
  </svg>
);

PlanNature.propTypes = {
  className: PropTypes.string
};

export default PlanNature;
